/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import { Theme } from "@mui/material";

const teaserCardStyle = {
  paper: {
    width: "240px",
    minHeight: "250px",
    padding: "1.3rem",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "auto",
    textAlign: "center",
  },
  linked: {
    "&:hover": {
      boxShadow: "0px 0px 12px 0px rgba(23,107,103,1)",
      cursor: "pointer",
    },
  },
  notLinked: {
    cursor: "default",
  },
  imageCircleContainer: {
    alignItems: "stretch",
    width: "120px",
    height: "120px",
    padding: "25px",
    borderRadius: "50% !important",
    border: "1px solid #333333",
    textAlign: "center",
  },
  imageContainer: {
    alignItems: "stretch",
    height: "140px",
    padding: "5px",
    textAlign: "center",
  },
  icon: {
    width: "auto",
    height: "100%",
  },
  heading: (theme: Theme) => ({
    fontSize: "1.5rem",
    lineHeight: 1.3,
    margin: "10px 0 0 0",
    [theme.breakpoints.only("xs")]: {
      marginTop: "25px",
    },
  }),
  default: {
    color: "text.primary",
  },
  primary: {
    color: "primary.main",
  },
  mobileCta: {
    marginTop: "10px",
    padding: "0.5rem 0",
    color: "primary.main"
  },
  subHeading: {
    marginTop: ".5rem",
  },
};

export default teaserCardStyle;
